import { getIsKiosk } from '../selectors/menus'
import { setShouldIncrementOrderNumber } from '../VNOrders/ActionCreators'

export const SET_CART_FROM_TAB = 'SET_CART_FROM_TAB'
export const SET_CART_FROM_RECOVERY = 'SET_CART_FROM_RECOVERY'
export const ADD_TO_CART = 'ADD_TO_CART'
export const ADD_TO_CART_OR_INCREMENT = 'ADD_TO_CART_OR_INCREMENT'
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART'
export const UPDATE_CART_ITEM_QUANTITY = 'UPDATE_CART_ITEM_QUANTITY'
export const SAFELY_UPDATE_CART_ITEM_QUANTITY = 'SAFELY_UPDATE_CART_ITEM_QUANTITY'
export const INCREMENT_CART_ITEM_QUANTITY = 'INCREMENT_CART_ITEM_QUANTITY'
export const SAFELY_INCREMENT_CART_ITEM_QUANTITY = 'SAFELY_INCREMENT_CART_ITEM_QUANTITY'
export const DECREMENT_CART_ITEM_QUANTITY = 'DECREMENT_CART_ITEM_QUANTITY'
export const SAFELY_DECREMENT_CART_ITEM_QUANTITY = 'SAFELY_DECREMENT_CART_ITEM_QUANTITY'
export const UPDATE_CART_ITEM_MODIFIERS = 'UPDATE_CART_ITEM_MODIFIERS'
export const SAFELY_UPDATE_CART_ITEM_NOTES = 'SAFELY_UPDATE_CART_ITEM_NOTES'
export const UPDATE_CART_ITEM_NOTES = 'UPDATE_CART_ITEM_NOTES'
export const CLEAR_CART = 'CLEAR_CART'
export const CLEAR_FOCUS = 'CLEAR_FOCUS'
export const ADD_NOTES_TO_CART = 'ADD_NOTES_TO_CART'
export const ADD_ORDER_NOTES_TO_CART = 'ADD_ORDER_NOTES_TO_CART'
export const UPDATE_OPEN_PRICE_ITEM = 'UPDATE_OPEN_PRICE_ITEM'
export const SET_SIGNATURE_DEFAULTS = 'SET_SIGNATURE_DEFAULTS'
export const SET_EXEMPT_DATA = 'SET_EXEMPT_DATA'

export const setCartFromRecovery = ({ lineItems }) => ({
  type: SET_CART_FROM_RECOVERY,
  payload: { lineItems },
})
setCartFromRecovery.type = SET_CART_FROM_RECOVERY

export const setCartFromTab = ({ lineItems }) => ({
  type: SET_CART_FROM_TAB,
  payload: { lineItems },
})

setCartFromTab.type = SET_CART_FROM_TAB

export const addToCart = ({
  itemId,
  modifiers = [],
  quantity = 1,
  isAlcohol = false,
  notes = null,
  openPriceInCents = null,
  originalPriceInCents = null,
  openName = null,
  managerId = null,
}) => ({
  type: ADD_TO_CART,
  payload: { itemId, modifiers, quantity, isAlcohol, notes, openPriceInCents, originalPriceInCents, openName, managerId },
})

addToCart.type = ADD_TO_CART

export const addToCartOrIncrement = ({ itemId }) => ({
  type: ADD_TO_CART_OR_INCREMENT,
  payload: { itemId },
})

addToCartOrIncrement.type = ADD_TO_CART_OR_INCREMENT

export const removeFromCart =
  ({ index }) =>
  (dispatch, getState) => {
    const state = getState()
    const isCartEmpty = state.cart?.lineItems?.length === 1
    const isKiosk = getIsKiosk(state)

    if (isCartEmpty && !isKiosk) {
      dispatch(setShouldIncrementOrderNumber())
    }

    dispatch({
      type: REMOVE_FROM_CART,
      payload: { index },
    })
  }

removeFromCart.type = REMOVE_FROM_CART

export const updateCartItemQuantity = ({ index, quantity }) => {
  if (quantity === 0) {
    return removeFromCart({ index })
  }

  return {
    type: UPDATE_CART_ITEM_QUANTITY,
    payload: { index, quantity },
  }
}

updateCartItemQuantity.type = UPDATE_CART_ITEM_QUANTITY

export const updateOpenPriceItem = ({ index, openName, openPriceInCents, originalPriceInCents, managerId = null }) => {
  return {
    type: UPDATE_OPEN_PRICE_ITEM,
    payload: { index, openName, openPriceInCents, originalPriceInCents, managerId },
  }
}

updateOpenPriceItem.type = UPDATE_OPEN_PRICE_ITEM

export const safelyUpdateCartItemQuantity = ({ index, quantity }) => ({
  type: SAFELY_UPDATE_CART_ITEM_QUANTITY,
  payload: { index, quantity },
})

safelyUpdateCartItemQuantity.type = SAFELY_UPDATE_CART_ITEM_QUANTITY

export const incrementCartItemQuantity = ({ index }) => ({
  type: INCREMENT_CART_ITEM_QUANTITY,
  payload: { index },
})

incrementCartItemQuantity.type = INCREMENT_CART_ITEM_QUANTITY

export const safelyIncrementCartItemQuantity = ({ index }) => ({
  type: SAFELY_INCREMENT_CART_ITEM_QUANTITY,
  payload: { index },
})

safelyIncrementCartItemQuantity.type = SAFELY_INCREMENT_CART_ITEM_QUANTITY

export const decrementCartItemQuantity = ({ index }) => ({
  type: DECREMENT_CART_ITEM_QUANTITY,
  payload: { index },
})

decrementCartItemQuantity.type = DECREMENT_CART_ITEM_QUANTITY

export const safelyDecrementCartItemQuantity = ({ index }) => ({
  type: SAFELY_DECREMENT_CART_ITEM_QUANTITY,
  payload: { index },
})

safelyDecrementCartItemQuantity.type = SAFELY_DECREMENT_CART_ITEM_QUANTITY

export const updateCartItemModifiers = ({ index, modifiers = [] }) => ({
  type: UPDATE_CART_ITEM_MODIFIERS,
  payload: { index, modifiers },
})

updateCartItemModifiers.type = UPDATE_CART_ITEM_MODIFIERS

export const updateCartItemNotes = ({ index, notes = '' }) => ({
  type: UPDATE_CART_ITEM_NOTES,
  payload: { index, notes },
})

updateCartItemNotes.type = UPDATE_CART_ITEM_NOTES

export const setSignatureDefaults = (selectedTipIndex, selectedTipAmount, shouldShowCharityFirst = false, signature) => ({
  type: SET_SIGNATURE_DEFAULTS,
  payload: { selectedTipIndex, selectedTipAmount, shouldShowCharityFirst, signature },
})

setSignatureDefaults.type = SET_SIGNATURE_DEFAULTS

export const safelyUpdateCartItemNotes = ({ index, notes = '' }) => ({
  type: SAFELY_UPDATE_CART_ITEM_NOTES,
  payload: { index, notes },
})

safelyUpdateCartItemNotes.type = SAFELY_UPDATE_CART_ITEM_NOTES

export const clearCart = () => ({
  type: CLEAR_CART,
})

clearCart.type = CLEAR_CART

export const clearFocus = () => ({
  type: CLEAR_FOCUS,
})

clearFocus.type = CLEAR_FOCUS

export const addNotesToCart = (userNotes) => ({
  type: ADD_NOTES_TO_CART,
  payload: { userNotes },
})

addNotesToCart.type = ADD_NOTES_TO_CART

export const addOrderNotesToCart = (orderNotes) => ({
  type: ADD_ORDER_NOTES_TO_CART,
  payload: { orderNotes },
})

addOrderNotesToCart.type = ADD_ORDER_NOTES_TO_CART

export const setTaxExemptData = ({ reason, taxExempt, taxExemptApproverUuid }) => ({
  type: SET_EXEMPT_DATA,
  payload: {
    reason,
    taxExempt,
    taxExemptApproverUuid,
  },
})

setTaxExemptData.type = SET_EXEMPT_DATA
